import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 20, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M15.44 4.5l4.06 4.06V19.5h-15v-15h10.94zm0-1.5a1.49 1.49 0 011.055.434l.001.001 4.07 4.07A1.489 1.489 0 0121 8.561V19.5 8.56 19.5a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3h10.94z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M7.19 13.19a1.5 1.5 0 011.06-.44h7.5a1.5 1.5 0 011.5 1.5v6a.75.75 0 01-1.5 0v-6h-7.5v6a.75.75 0 01-1.5 0v-6c0-.398.158-.78.44-1.06zM8.25 6.75A.75.75 0 019 6h5.25a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
